import { GetUrlParameterValue, TaxInfo } from './_Shared.js';

TaxInfo.Input = {

    Init: function () {

        // only write to model variables initially, not if coming back from controller SaveInput after an error without the parameters in the URL
        if ($("#RegistrationID").val() == "") {
            $("#RegistrationID").val(GetUrlParameterValue('registrantid'));
        }

        if ($("#GroupID").val() == "") {
            $("#GroupID").val(GetUrlParameterValue('groupid'));
        }

        if ($("#EventID").val() == "") {
            $("#EventID").val(GetUrlParameterValue('eventid'));
        }

        if ($("#FirstName").val() == "") {
            $("#FirstName").val(GetUrlParameterValue('gfname'));
        }

        if ($("#LastName").val() == "") {
            $("#LastName").val(GetUrlParameterValue('glname'));
        }

        TaxInfo.Input.ControlFieldVisibility();
        
        $("#TaxClassification").change(function () {
            TaxInfo.Input.ControlFieldVisibility();
        })

    },

    ControlFieldVisibility: function () {

        if ($("#TaxClassification").val() == "6") {
            $("#LLCTaxSection").show();
            $("#OtherTaxClassification").val("");
            $("#OtherTaxSection").hide();
        }
        else if ($("#TaxClassification").val() == "7") {
            $("#OtherTaxSection").show();
            $("#LLCTaxClassification").val("0");
            $("#LLCTaxSection").hide();
        }
        else {
            $("#LLCTaxClassification").val("0");
            $("#LLCTaxSection").hide();
            $("#OtherTaxClassification").val("");
            $("#OtherTaxSection").hide();
        }
    }

}